import { useCallback } from 'react'
import { endOfDay } from 'date-fns'
import { useFilteredTasks } from './useFilteredTasks'
import type { TaskDocument } from '@/lib/db/rxdb/schemas/task'

/**
 * Hook that returns today's tasks: due by the end of today, or a range that has
 * started (start date <= end of today), so setting a range doesn't drop a task
 * out of Today. Open status, no parent.
 */
export function useTodayTasks(options?: { includeSubTasks?: boolean }) {
  // Display → Show sub-tasks flattens them into the list (design 28b).
  const includeSubTasks = options?.includeSubTasks ?? false
  const predicate = useCallback(
    (task: TaskDocument, openStatusIds: ReadonlyArray<string>) => {
      const endOfToday = endOfDay(new Date()).getTime()
      return (
        !!task.dueDate &&
        (task.dueDate <= endOfToday || (!!task.startDate && task.startDate <= endOfToday)) &&
        openStatusIds.includes(task.statusId) &&
        (includeSubTasks || !task.parentId) &&
        !task.isArchived
      )
    },
    [includeSubTasks],
  )

  return useFilteredTasks({ predicate, assignedToMeOnly: true })
}
